import { CiSaveDown2 } from 'react-icons/ci';
import { PlusIcon } from '@heroicons/react/24/solid';
import { useEffect, useState } from 'react';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import { TreeViewCollapseIcon, TreeViewExpandIcon } from '@mui/x-tree-view';
import { checkAvailableDelOrg, deleteOrgUnit, getOrgUnits, getUserOrgTree } from '../../services/ api_services';
import OrgMemberDialog from '../../components/dialogs/OrgMemberDialog';
import { MinusIcon } from '@heroicons/react/24/outline';
import { ROLES } from '../../core/constants';
import { HttpStatusCode } from 'axios';

const searchType = [
  { name: 'Y', id: '0001' },
  { name: 'N', id: '0009' },
];

export default function TreeViewDetail() {
  const stats = [
    { id: 1, name: '총', value: '8,000+' },
    { id: 2, name: '발행', value: '3%' },
    { id: 3, name: '잔여', value: '99.9%' },
  ];

  const initCouponCount = {
    org_name: '',
    total_cnt: 0,
    publish_cnt: 0,
    remain_cnt: 0,
  };

  const initialVariables = {
    newOrgName: 0, //지사명
    maxG: 0, //발행 회원권
    normalG: 0, // 사용 회원권
    useCode: '',
  };

  const [count, setCount] = useState(initCouponCount);
  const [cond, setCond] = useState(initialVariables);
  const [treeData, setTreeData] = useState([]);
  const [selectedChildren, setSelectedChildren] = useState([]);
  const [selectedNode, setSelectedNode] = useState(null);
  const [popupOrgId, setPopupOrgId] = useState(null);
  const [checkDelOrgId, setCheckDelOrgId] = useState(0);

  const adminOrgId = sessionStorage.getItem("adminOrgId");
  const adminSeq = sessionStorage.getItem("adminSeq");
  const adminLevelCd = sessionStorage.getItem("adminLevelCd");

  useEffect(() => {
    if (adminOrgId) {
      selectUserOrgTree();
    }
  }, [adminOrgId]);

  useEffect(() => {
    console.log('selectedChildren ==>', selectedChildren);
  }, [selectedChildren]);

  useEffect(() => {
    if (checkDelOrgId === 0){
      return;
    }
    callAvailableDelOrg();
  }, [checkDelOrgId]);

  //상세정보 채우기 위한 회원구분(조직) Api 로 값 불러오기
  const selectUserOrgTree = async () => {
    try {
      const orgData = {
        org_id: adminOrgId,
        use_yn: "0001"
      }
      console.log("🚀 ~ TreeViewDetail UserOrgTree ~ orgData:", orgData)
      const response = await getUserOrgTree(orgData);
      console.log("🚀 ~ TreeViewDetail UserOrgTree ~ response:", response);

      const nested = buildTree(response.data);
      console.log('nested ==>', nested);
      setTreeData(nested);

      // 화면이 갱신되도록 SelectedChildren 값 넣기
      if (selectedNode !== null && nested !== null && response.data !== null) {
        let listVal = response.data.filter((item) => (item.parent_org_id === selectedNode.org_id) )
        console.log("listVal  =>", listVal);
        selectedNode.children = listVal;
        setSelectedChildren(listVal);
      }

      // 윗쪽 카운팅도 갱신되도록 수정
      if (selectedNode) {
        const updatedNode = findOrgById(nested, selectedNode.org_id);
        if (updatedNode) {
          setCount({
            org_name: updatedNode.org_name,
            total_cnt: updatedNode.total_coupon || 0,
            publish_cnt: updatedNode.issued_coupon || 0,
            remain_cnt: (updatedNode.total_coupon || 0) - (updatedNode.issued_coupon || 0),
          });
        }
      }
    } catch (error) {
      console.error("옵션 데이터를 불러오지 못했습니다:", error);
    }
  };

  const handleOnClickSave = async () => {
    console.log('cond ==>', cond);
    console.log('saved button clicked ==>', selectedChildren);

    if (!selectedChildren || selectedChildren.length === 0) return;

    const parentNode = selectedNode;
    console.log("parentNode ==>", parentNode);
    if (!parentNode) { return;}

    // 부모의 total_coupon
    const parentTotalCoupon = parentNode.total_coupon || 0;

    // 같은 parent_org_id를 가진 자식 노드들의 total_coupon 합계
    const totalChildCoupons = selectedChildren.reduce((sum, child) => {
      return sum + (child.total_coupon || 0);
    }, 0);

    // 합계가 부모의 total_coupon을 초과하는지 확인
    if (totalChildCoupons > parentTotalCoupon) {
      alert(`하위 총 회원권 수(${totalChildCoupons})가 부모 총 회원권 수(${parentTotalCoupon})를 초과합니다.`);
      return; // 저장 로직 중단
    }

    try {
      const hasEmptyOrgName = selectedChildren.some(
        (child) => !child.org_name || child.org_name.trim() === ""
      );

      if (hasEmptyOrgName) {
        alert("지사명이 비어있는 칸이 있습니다.\n지사명을 입력해 주세요.");
        return;
      }

      // 변경이 있는 데이터만 Update 및 Insert 하도록 수정
      const newChildren = selectedChildren.filter(child => String(child.org_id).startsWith("new"));
      const originalChildren = selectedNode.children || [];

      const updatedChildren = selectedChildren.filter(child => {
        const original = originalChildren.find(orig => orig.org_id === child.org_id);
        if (!original) return false;

        const keysToCompare = ["org_name", "total_coupon", "use_yn"];
        return keysToCompare.some(key => child[key] !== original[key]);
      });

      const filteredChildrenToSend = [...newChildren, ...updatedChildren];

      if (filteredChildrenToSend.length === 0) {
        alert("변경된 사항이 없습니다.");
        return;
      }

      const orgReqData = {
        admin_seq: adminSeq,
        children: filteredChildrenToSend.map((item) => ({
          ...item,
          org_id: String(item.org_id).includes("new") ? "" : item.org_id,
        })),
      }

      console.log("updatedChildren==>", filteredChildrenToSend);
      await getOrgUnits(orgReqData);
      await selectUserOrgTree();

    } catch (error) {
      console.log(error);
    }

  };

  const callAvailableDelOrg = async() => {

    const orgInTree = findOrgById(treeData, checkDelOrgId);
    console.log(orgInTree);
    if (orgInTree.total_coupon > 0) {
      alert(orgInTree.org_name + " 발행된 쿠폰이 있어서 삭제할 수 없습니다.");
      setCheckDelOrgId(0);
      return;
    }

    const response = await checkAvailableDelOrg(checkDelOrgId);
    if (response.data.includes("available")){
      const isConfirmed = window.confirm("[" + orgInTree.org_name +"] 정말 삭제하시겠습니까?");
      if (isConfirmed) {
        const response = await deleteOrgUnit(checkDelOrgId);
        if (response.status === HttpStatusCode.Ok) {
          setSelectedChildren((prev) => prev.filter((child) => child.org_id !== checkDelOrgId));
          selectUserOrgTree();
          console.log("삭제됨");
        }
      } else {
        console.log("삭제 취소됨");
      }
    } else {
      const reason = response.data.replace("exist ", "");
      const messages = {
        refCount: " 조직의 추천인이 있어서 삭제할 수 없습니다.",
        adminCount: " 조직의 관리자가 있어서 삭제할 수 없습니다.",
        parentCount: " 하위 조직이 있어서 삭제할 수 없습니다.",
      };

      const message = messages[reason];
      if (message) {
        alert(orgInTree.org_name + message);
      }
    }
    setCheckDelOrgId(0);
  };

  const buildTree = (flatData) => {
    const map = {};
    const roots = [];

    flatData.forEach((node) => {
      map[node.org_id] = { ...node, children: [] };
    });

    flatData.forEach((node) => {
      if (node.parent_org_id && map[node.parent_org_id]) {
        map[node.parent_org_id].children.push(map[node.org_id]);
      } else {
        roots.push(map[node.org_id]);
      }
    });

    return roots;
  };

  // 해당 org_id의 트리 찾기 함수
  const findOrgById = (orgList, targetId) => {
    for (const org of orgList) {
      if (org.org_id === targetId) return org;
      if (org.children) {
        const found = findOrgById(org.children, targetId);
        if (found) return found;
      }
    }
    return null;
  };

  // 하위 조직이 있는지 확인
  const hasValidChildren = (org) => {
    if ((!org.children || org.children.length === 0) && org.referrer_count === 0 ) return false;
    if (org.referrer_count > 0) return true;
    return org.children.some((child) => {
      return (
        child.total_coupon > 0 || // 총 쿠폰이 남아있는 경우
        hasValidChildren(child) // 자식의 자식에게도 검사
      );
    });
  };

  const handleShowPopup = (e, orgId) => {
    console.log('handleShowPopup orgId===>', orgId);
    
    e.stopPropagation();
    setPopupOrgId(orgId);
  };

  //트리 클릭시 자식 데이터 input에 기입 이벤트
  const handleTreeItemClick = (e, node) => {
    // e.stopPropagation();

    // 깊은 복사로 node.children을 복사
    let childrenCopy = Array.isArray(node.children)
    ? JSON.parse(JSON.stringify(node.children))
    : [];

    // 자식 노드가 없으면 새 노드 생성
    if (childrenCopy.length === 0) {
      const newChild = {
        org_id: 'new1',
        org_name: '',
        parent_org_id: node.org_id,
        org_level: (node.org_level || 0) + 1,
        depth: (node.depth || 0) + 1,
        full_id: '',
        full_path: '',
        use_yn: '0001',
        total_coupon: 0,
        issued_coupon: 0,
        user_count : 0,
        auto_approval_yn: 'N',
      };
      childrenCopy = [newChild];
    }

    setCount({
      org_name: node.org_name,
      total_cnt: node.total_coupon || 0,
      publish_cnt: node.issued_coupon || 0,
      remain_cnt: (node.total_coupon || 0) - (node.issued_coupon || 0),
    });

    setSelectedChildren(childrenCopy); // 하위 노드 저장
    setSelectedNode(node); // 선택된 노드 정보 저장
  };

  //   (총: {node.data1} / 발행: {node.data2} / 잔여: {node.data1 - node.data2})

  //트리 UI 생성
  const renderTree = (node) => {

    const total = node.total_coupon || 0;
    const issued = node.issued_coupon || 0;
    const remain = total - issued;

    return (
    <TreeItem
      key={node.org_id} // 고유 키
      itemId={`${node.org_id}`} // 선택 이벤트에서 사용할 ID
      label={
        <div>
          <span onClick={(e) => handleTreeItemClick(e, node)}>{node.org_name}
            <span className="ml-2 text-xs text-gray-500">(총: {total.toLocaleString()} / 발행: {issued.toLocaleString()} / 잔여: {remain.toLocaleString()})</span>
          </span>
          <span className="ml-2 text-xs" onClick={(e)=>handleShowPopup(e, node.org_id)}> 회원: {node.user_count}명</span>

          {popupOrgId === node.org_id && (
            <OrgMemberDialog
              isOpen={popupOrgId === node.org_id}
              onClose={() => setPopupOrgId(null)}
              orgId={node.org_id}
          />
          )}
        </div>
      }
    >
      {Array.isArray(node.children) ? node.children.map((child) => renderTree(child)) : null}
    </TreeItem>
    );
  };

  const handleAddChildRow = () => {
    console.log('selectedChildren ==>', selectedChildren, "selectedNode===>", selectedNode);

    if (!selectedNode) return;

    const newChild = {
      org_id: 'new'+(selectedChildren.length+1),
      org_name: '',
      parent_org_id: selectedNode.org_id,
      org_level: selectedNode.org_level + 1,
      depth: selectedNode.depth + 1,
      full_id: '',
      full_path: '',
      use_yn: '0001',
      total_coupon: 0,
      issued_coupon: 0,
      user_count : 0,
      auto_approval_yn: 'N',
    };
    // console.log('newChild ==>', newChild);
    setSelectedChildren((prev) => [...prev, newChild]);
  };

  const handleRemoveChildRow = (org_id) => {
    if (typeof org_id !== 'number' || isNaN(org_id)){
      return;
    }
    console.log('handleRemoveChildRow', org_id);
    setCheckDelOrgId(org_id);
  };

  return (
    <div className="mx-auto max-w-full flex flex-row">
      <div className="inline-block py-4 align-middle sm:px-2 w-1/3  lg:px-8 px-6 bg-white shadow rounded">
        <span className="flex text-center justify-start align-middle text-nowrap text-gray-700 font-semibold text-xl">
          조직도 관리
        </span>
        <div className="py-2  sm:grid-cols-6 min-h-24">
          <div className="w-full">
            <SimpleTreeView expandIcon={<TreeViewExpandIcon />} collapseIcon={<TreeViewCollapseIcon />}>
              {treeData.map(renderTree)}
            </SimpleTreeView>
          </div>
        </div>
      </div>

      <div className="inline-block py-4 align-middle sm:px-6 w-2/3 lg:px-8 px-6 bg-white shadow rounded">
        <div className="flex flex-row justify-between gap-x-8">
          <div className="">
            <span className="text-sm text-black">
              {count.org_name} (
              {stats.map((stat, index) => (
                <span
                  key={stat.id}
                  style={{
                    marginRight: index === 0 || index === 1 ? '0.5rem' : '0',
                  }}
                >
                  {stat.name}:{' '}
                  <span className="font-semibold">
                    {stat.id === 1 ? count.total_cnt.toLocaleString() : stat.id === 2 ? count.publish_cnt.toLocaleString() : count.remain_cnt.toLocaleString()}
                  </span>
                </span>
              ))}
              )
            </span>
          </div>
          <div className="flex items-center align-middle">
            <div className="bg-blue-600 p-1.5 rounded-md w-fit mr-4 shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
              <PlusIcon className="w-5 h-5 text-white" onClick={() => handleAddChildRow()} />
            </div>
            <button
              type="button"
              className="w-32 rounded-md inline-flex gap-x-1 items-center justify-center bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
              onClick={() => handleOnClickSave()}
            >
              <CiSaveDown2 className="-ml-0.5 h-5 w-5" aria-hidden="true" />
              저장
            </button>
          </div>
        </div>
        <div className="w-full overflow-x-auto overflow-y-hidden">
          <table className=" w-full table-fixed divide-y divide-gray-200 mt-6">
            <thead key={'variables_header'}>
              <tr>
                <th
                  scope="col"
                  className="w-[10px] py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-black sm:pl-0"
                >
                  NO
                </th>
                <th scope="col" className="w-[40px] px-3 py-3.5 text-center text-sm font-semibold text-black">
                  지사명
                </th>
                <th scope="col" className=" w-[40px] px-3 py-3.5 text-center text-sm font-semibold text-black">
                  발행 회원권
                </th>
                <th scope="col" className=" w-[30px] px-3 py-3.5 text-center text-sm font-semibold text-black">
                  사용 / 대기
                </th>
                <th scope="col" className=" w-[20px] px-3 py-3.5 text-center text-sm font-semibold text-black">
                  사용유무
                </th>
                <th
                  scope="col"
                  className="w-[10px] py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-black sm:pl-0"
                ></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {Array.isArray(selectedChildren) &&
                selectedChildren.length > 0 &&
                selectedChildren.map((child, index) => (
                  <tr key={child.org_id || `new-${index}`}>
                    <td className="w-[40px] whitespace-nowrap text-center py-4 pl-4 pr-3 text-sm font-medium text-black sm:pl-0">
                      {index + 1}
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-black">
                      <input
                        className={`w-full rounded-md border-gray-300 ${child.use_yn === searchType[1].id ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : '' }`}
                        value={child.org_name || ''}
                        maxLength={100}
                        type={'text'}
                        id={child.org_id || `new-${index}`}
                        disabled={child.use_yn === searchType[1].id}
                        onChange={(e) => {
                          const updated = selectedChildren.map((c) =>
                            c.org_id === child.org_id ? { ...c, org_name: e.target.value } : c
                          );
                          setSelectedChildren(updated);
                        }}
                      />
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-black">
                      <input
                        className={`w-full rounded-md border-gray-300 ${child.use_yn === searchType[1].id ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : '' }`}
                        value={
                          child.total_coupon === 0 || child.total_coupon
                            ? child.total_coupon.toLocaleString()
                            : ''
                        }
                        inputMode={'numeric'}
                        type={'text'}
                        disabled={child.use_yn === searchType[1].id}
                          onChange={(e) => {
                            // 쉼표 제거 후 숫자 변환
                            const numberValue = Number(e.target.value.replace(/,/g, '')) || 0;
                            const updated = selectedChildren.map((c) =>
                              c.org_id === child.org_id ? { ...c, total_coupon: numberValue } : c
                            );
                            setSelectedChildren(updated);
                            setCond((preVal) => ({
                              ...preVal,
                              maxG: numberValue,
                            }));
                          }
                        }
                      />
                    </td>
                    <td className="whitespace-nowrap px-3 text-center py-4 text-sm text-gray-500">
                      {`${child.referrer_count || 0} / ${child.wait_count || 0}`}
                    </td>
                    <td className="whitespace-nowrap px-3 text-center py-4 text-sm text-gray-300">
                      <select
                        id="location"
                        name="location"
                        className="w-32 rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        value={child.use_yn}
                        onChange={(e) => {

                          const orgInTree = findOrgById(treeData, child.org_id);
                          if (hasValidChildren(orgInTree)) {
                            alert("해당 조직 또는 하위 조직에 발급된 회원권이 있어 상태를 변경할 수 없습니다.\n관리자에게 문의해 주세요.");
                            return;
                          }

                          const selectedValue = e.target.value;
                          const updated = selectedChildren.map((c) =>
                            c.org_id === child.org_id ? { ...c, use_yn: selectedValue } : c
                          );
                          setSelectedChildren(updated);
                          console.log("updated ==>", updated);
                        }}
                      >
                        {searchType.map((item) => {
                          return <option option key={item.id} value={item.id}>{item.name}</option>;
                        })}
                      </select>
                    </td>
                    {/* // 마이너스 버튼 사용하지 않음 */}
                    {adminLevelCd === ROLES.Admin?
                    <td className="whitespace-nowrap px-3 text-center py-4 text-sm text-gray-300">
                      <div className="bg-red-600 p-1.5 rounded-md w-fit mr-4 shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600">
                        <MinusIcon className="w-5 h-5 text-white" onClick={() => handleRemoveChildRow(child.org_id)} />
                      </div>
                    </td>:<></>
                    }
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
